import { c, classy, m } from '@onfido/castor';
import { useField } from '@onfido/castor-react';
import React from 'react';
import { withRef } from '../../../utils';
export const NativeSelect = withRef(function NativeSelect({ className, invalid, ...restProps }, ref) {
    const { disabled, touched } = useField();
    return (React.createElement("select", { disabled: disabled, ...restProps, ref: ref, className: classy(c('select-native'), m({ invalid, touched }), className) }));
});
//# sourceMappingURL=native-select.js.map